import * as React from 'react';
import { useQuery } from '@tanstack/react-query';

import { getAmenities } from '@/api/amenities';
import { useDialog } from '@/hooks/v2/use-dialog';
import { useUser } from '@/hooks/v2/use-user';

import { AmenitiesTable } from './components/amenities-table';

export function CommunityAmenitiesPage(): React.JSX.Element {
  const dialog = useDialog();
  const { community } = useUser();

  if (!community) {
    return <div>No community found</div>;
  }

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['amenities', community?.id],
    queryFn: () => getAmenities(community?.id || ''),
  });

  const handleOnSuccess = React.useCallback(async () => {
    await refetch();
    dialog.handleClose();
  }, [dialog, refetch]);

  const amenities = data?.amenities;

  return <AmenitiesTable loading={isLoading} onCreated={handleOnSuccess} rows={amenities ?? []} />;
}





